import {AppNavigationState} from './app-navigation.state';


export const appNavigationStateInitial: AppNavigationState = {
  buttonEnabled: true,
}
